<template>
    <div>
        <app-form-textarea-input
            title="Escriba comentario"
            label="Escriba comentario"
            v-model="comment.comment"
            error-message="Debe escribir el comentario"
            :has-error="$v.comment.comment.$error"
            :required="required"
        />
    </div>
</template>
<script>
import petitionsRepository from "../../../repositories/petitions.repository.js";
import FormSelectInput from "../../UI/Controls/Forms/FormSelectInput.vue";
import FormTextareaInput from "../../UI/Controls/Forms/FormTextareaInput.vue";
import { required } from "vuelidate/lib/validators";
export default {
    components: {
        appFormTextareaInput: FormTextareaInput,
        appFormSelectInput: FormSelectInput
    },

    props: {
        id: {
            type: String,
            required: true
        },
        petition: {
            type: Object
        },
        onSave: {
            type: Function
        },
        hasError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            comment: {
                petitionId: "",
                userId: "",
                statusId: "",
                comment: ""
            }
        };
    },

    validations: {
        comment: {
            comment: { required }
        }
    },

    methods: {
        saveComment() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            }

            this.comment.userId = this.user.id;
            this.comment.petitionId = this.petition.id;
            this.comment.statusId = this.petition.petition_status_id;

            const pr = Object.assign({}, petitionsRepository);
            pr.saveCommentAssignation(this.comment)
                .then(data => {
                    if (data.status) {
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                        toastr.success(data.msg);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al guardar comentario");
                });
        },
        cleanFields() {
            Object.keys(this.comment).map(key => (this.comment[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },

    created() {
        this.$bus.$on(`${this.id}.save`, this.saveComment);
        this.$bus.$on(`${this.id}.clean`, this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off(`${this.id}.save`);
    }
};
</script>
